import React from 'react';
import { Map, Marker, Popup, TileLayer } from 'react-leaflet';
import { Link } from 'react-router-dom';
import ReplyIcon from '@material-ui/icons/Reply';
const data = require('./data.json');

const App = () => {
	return (
		<div>
			<Link to={'/'} className="p-3">
				<ReplyIcon className="pb-2" style={{ fontSize: 'x-large', cursor: 'pointer' }} />{' '}
				<span style={{ fontSize: 'large' }}>Back</span>
			</Link>
			<Map center={[ 34.6873377, 135.5237668 ]} zoom={12}>
				<TileLayer
					url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
					attribution="&copy; <a href=&quot;http://osm.org/copyright&quot;>OpenStreetMap</a> contributors"
				/>

				{data.map((d) => (
					<Marker key={d.id} position={[ d.position[0], d.position[1] ]}>
						<Popup position={[ d.position[0], d.position[1] ]} >
							<div>
								<h2>{d.name}</h2>
								<small>{d.address}</small>
								<p>{d.description}</p>
							</div>
						</Popup>
					</Marker>
				))}
			</Map>
		</div>
	);
};

export default App;
